import { useTranslation } from "react-i18next";
import { chartSeriesBgClass, ColorDot } from "components/charts";
import { StyledTabs } from "components/StyledTabs";
import { ALL_MARKETS } from "contexts/SalesDataContext";

interface MarketToggleProps {
  markets: string[];
  marketFocus: string;
  onChange: (market: string) => void;
}

export const MarketToggle = ({
  markets,
  marketFocus,
  onChange,
}: MarketToggleProps) => {
  const { t } = useTranslation(["productDetails"]);

  if (markets.length < 2) {
    return null;
  }

  const tabs = [
    {
      value: ALL_MARKETS,
      label: t("salesData.marketToggle.allMarkets"),
      testId: "market-toggle-all",
    },
    ...markets.map((market, index) => ({
      value: market,
      label: market,
      testId: `market-toggle-${market}`,
      // Colour by position in the shared market order, matching the chart series.
      icon: <ColorDot className={chartSeriesBgClass(index)} shape="round" />,
    })),
  ];

  return (
    <StyledTabs
      activeTab={marketFocus}
      onTabChange={onChange}
      variant="pill"
      listClassName="space-x-0.5"
      triggerClassName="px-3 text-xs"
      tabs={tabs}
    />
  );
};
